function Footer() {
  return (
    <footer className="border-t border-[#d8d0be] bg-[#fbf8ef] px-4 py-6 text-center text-sm text-[#43513f]">
      <p>Emma's Court Community Garden &copy; {new Date().getFullYear()}</p>
    </footer>
  );
}

export default Footer;
